import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import DatePicker from "react-datepicker";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import '../requisitionReports.css'
import getAllRequisitionStatus from '../../../apis/getallRequisitionStatus/getAllRequisitionStatus';
import { NotificationManager } from "react-notifications";
import jsonConfig from "../../../Config.json"



const JobReportSearch = ({ allDivisionNames, setAdditionalFilter_activity, allClientNames, setIsfilterSearch, setAdditionalFilter, selectedTab, setAdditionalFilter_submission, setAdditionalFilter_workReport, setAdditionalFilter_recruiter_activity, setAdditionalFilter_resume_report, setFilterValues_accessreport, allTeamNames, setAdditionalFilter_rtr_report }) => {
    const [formValues, setFormValues] = useState({
        divisionId: [],
        clientName: [],
        clientJobId: "",
        requisitionStatus: [],
        requistionSubStatus: [],
        placementType: [],
        candidateStatus: [], // Add this field
        selected_date: {
            from: "",
            to: ""
        },
        start_date: {
            from: "",
            to: ""
        },
        joining_date: {
            from: "",
            to: ""
        },
        offer_release_date: {
            from: "",
            to: ""
        },
        interview_date: {
            from: "",
            to: ""
        },
        email: [],
        ipAddress: [],
        // RTR Report specific fields
        candidateName: "",
        candidateEmail: "",
        refId: "",
        rtrStatus: "",
        rtrSendDate: {
            from: "",
            to: ""
        },
        approvalDate: {
            from: "",
            to: ""
        },
        rejectDate: {
            from: "",
            to: ""
        }
    });
    const [selectedDateType, setSelectedDateType] = useState(""); // New state for radio button
    const [openSubList, setOpenSubList] = useState([]);
    const [statusNames, setStatusNames] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const placementTypeOption = [
        { PositionType: "Direct Placement" }, { PositionType: "Right To Hire" }, { PositionType: "Full Time" }, { PositionType: "Contract" }
    ];

    const rtrStatusOptions = [
        { label: "Pending", value: "pending" },
        { label: "Approved", value: "approved" },
        { label: "Rejected", value: "rejected" }
    ];




    useEffect(() => {
        setStatusList([])
        setSelectedDateType("") // Reset radio button selection
        setFormValues({
            divisionId: [],
            clientName: [],
            teamId: [],
            clientJobId: "",
            requisitionStatus: [],
            requistionSubStatus: [],
            placementType: [],
            candidateStatus: [], // Add this field
            start_date: {
                from: "",
                to: ""
            },
            selected_date: {
                from: "",
                to: ""
            },
            offer_release_date: {
                from: "",
                to: ""
            },
            interview_date: {
                from: "",
                to: ""
            },
            joining_date: {
                from: "",
                to: ""
            },
            email: [],
            ipAddress: [],
            // RTR Report specific fields
            candidateName: "",
            candidateEmail: "",
            refId: "",
            rtrStatus: "",
            rtrSendDate: {
                from: "",
                to: ""
            },
            approvalDate: {
                from: "",
                to: ""
            },
            rejectDate: {
                from: "",
                to: ""
            }
        })
    }, [selectedTab])


    useEffect(() => {
        const fetchStatusNames = async () => {
            try {
                const response = await getAllRequisitionStatus();
                const statusData = response?.data?.data || [];

                // Set all status names to the state
                setStatusNames(statusData);

                // Filter to find the "OPEN" status and set its sublist
                const openStatus = statusData.find(status => status.name === "OPEN");



                // Set sublist if "OPEN" is found, otherwise clear it
                setOpenSubList(openStatus?.subList || []);
            } catch (error) {
                console.error("Error fetching requisition status:", error);
            }
        };

        fetchStatusNames();
    }, []);




    let is_OPEN_Exist = formValues.requisitionStatus?.some(item => item === "OPEN") || false;
    useEffect(() => {
        if (!is_OPEN_Exist) {
            setFormValues(prevValues => ({
                ...prevValues,
                requistionSubStatus: [],


            }));
        }
    }, [is_OPEN_Exist])
    const subStatusName = Object.entries(jsonConfig.requisitionStatusCodes.OPENSUBSTATUS)

    const toCamelCase = (str) => {
        return str
            .toLowerCase() // Convert entire string to lowercase first
            .split("_") // Split on underscores
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
            .join(" "); // Join the words with a space
    };

    const candidateStatusOptions = Object.keys(jsonConfig.candidateRequisitionStatusCode).map((key) => ({
        label: toCamelCase(key), // Format label to be more readable
        value: jsonConfig.candidateRequisitionStatusCode[key] // CRS code value
    }));

    const handleStatusChange = (event, newValue) => {
        // Update the candidateStatus in formValues
        setFormValues(prevValues => ({
            ...prevValues,
            candidateStatus: newValue
        }));

        // Map the selected options to their values (CRS codes)
        const selectedValues = newValue.map((option) => option.value);

        // Update the status list
        setStatusList(selectedValues);
    };

    const handleAutocompleteChange = (event, newValue, fieldName) => {
        if (fieldName === "requisitionStatus") {
            // Map newValue to an array of status names (strings)
            const newValueArray = newValue.map(item => item.name);
            setFormValues(prevValues => ({
                ...prevValues,
                [fieldName]: newValueArray,
            }));
        } else if (fieldName === "requisition_SubStatus" && is_OPEN_Exist) {
            // Ensure that newValue is an array before using .map()
            const subStatusCodesArray = Array.isArray(newValue)
                ? newValue.map(item => {
                    // Find the corresponding code for the subName
                    const match = subStatusName.find(([name]) => name === item.subName);
                    return match ? match[1] : item.subName; // Return the code or the subName itself if no match
                })
                : [];

            setFormValues(prevValues => ({
                ...prevValues,
                requistionSubStatus: subStatusCodesArray, // Store only substatus codes as an array of strings
            }));
        } else if (fieldName === "placementType") {
            // Handle placementType similarly
            const newValueArray = newValue.map(item => item.PositionType);
            setFormValues(prevValues => ({
                ...prevValues,
                [fieldName]: newValueArray,
            }));
        }
        else if (fieldName === "clientJobId") {


            setFormValues(prevValues => ({
                ...prevValues,
                [fieldName]: newValue,
            }));
        } else {
            // Default case for other fields
            setFormValues(prevValues => ({
                ...prevValues,
                [fieldName]: newValue,
            }));
        }
    };


    const handleDivisionChange = (event, newValue) => {
        // Extract the _id values from the selected options

        const divisionIds = newValue.map(option => option._id);
        handleAutocompleteChange(event, divisionIds, 'divisionId')


        // const divisionIds = newValue.map(option => option.divisionName);

        // handleAutocompleteChange(event, divisionIds, 'divisionId')

    };

    const handleIPChange = (event) => {
        const { value } = event.target;
        if (value.trim() === "") {

            setFormValues((prevState) => ({
                ...prevState, ipAddress: [],
            }));
            return;

        }

        setFormValues((prevState) => ({
            ...prevState, ipAddress: [value],
        }));

    };


    const handleEmailChange = (event) => {
        const { value } = event.target;
        if (value.trim() === "") {
            setFormValues((prevState) => ({
                ...prevState, email: [],
            }));
            return;

        }

        setFormValues((prevState) => ({
            ...prevState, email: [value],
        }));

    };

    const handleClientNameChange = (event, newValue) => {
        // Extract the _id values from the selected options
        const clientNames = newValue.map(option => option._id);
        handleAutocompleteChange(event, clientNames, 'clientName');
    };

    const handleTeamNameChange = (event, newValue) => {
        // Extract the _id values from the selected options
        const teamIds = newValue.map(option => option._id);
        handleAutocompleteChange(event, teamIds, 'teamId');
    };

    const formatDate = (dateVal) => {
        let date = new Date(dateVal);
        let year = date.getFullYear();
        let month = (1 + date.getMonth()).toString();
        month = month.length > 1 ? month : "0" + month;
        let day = date.getDate().toString();
        day = day.length > 1 ? day : "0" + day;
        return year + "-" + month + "-" + day;
    };

    const handleDateChange = (date, field, subField) => {
        if (date instanceof Date && !isNaN(date)) {
            const formattedDate = formatDate(date); // Formats to yyyy-mm-dd
            setFormValues(prevValues => ({
                ...prevValues,
                [field]: {
                    ...prevValues[field],
                    [subField]: formattedDate
                }
            }));
        } else {
            setFormValues(prevValues => ({
                ...prevValues,
                [field]: {
                    ...prevValues[field],
                    [subField]: ""
                }
            }));
        }
    };


    const handleActivityEmail = (event) => {
        const { value } = event.target;
        if (value.trim() === "") {
            setFormValues((prevState) => ({
                ...prevState, email: [],
            }));
            return;

        }

        setFormValues((prevState) => ({
            ...prevState, email: value,
        }));

    }






    const validateDateRange = (from, to, fieldName) => {
        const fieldNameMapping = {
            start_date: "Joining Date",
            offer_release_date: "Offer Release Date",
            interview_date: "Interview Date",
            selected_date: "Start Date",
            joining_date: "Selected Date",
            rtrSendDate: "RTR Send Date",
            approvalDate: "Approval Date",
            rejectDate: "Reject Date"
        };

        // Skip validation if either 'from' or 'to' is an  --> ""
        if (!from || !to) {
            return true; // No validation needed if either value is empty
        }

        if (new Date(from) > new Date(to)) {
            // Get th  name from the mapping || or fall back to the fieldName if not found
            const displayName = fieldNameMapping[fieldName] || fieldName;
            NotificationManager.error(`Please enter a valid date in ${displayName}`, "Error", 10000);

            return false;
        }
        return true;
    };


    const handleSearch = () => {
        // Validate all date ranges using the helper function
        const dateFields = [
            { from: formValues.start_date?.from, to: formValues.start_date?.to, fieldName: 'start_date' },
            { from: formValues.offer_release_date?.from, to: formValues.offer_release_date?.to, fieldName: 'offer_release_date' },
            { from: formValues.interview_date?.from, to: formValues.interview_date?.to, fieldName: 'interview_date' },
            { from: formValues.joining_date?.from, to: formValues.joining_date?.to, fieldName: 'joining_date' },
            { from: formValues.rtrSendDate?.from, to: formValues.rtrSendDate?.to, fieldName: 'rtrSendDate' },
            { from: formValues.approvalDate?.from, to: formValues.approvalDate?.to, fieldName: 'approvalDate' },
            { from: formValues.rejectDate?.from, to: formValues.rejectDate?.to, fieldName: 'rejectDate' }

        ];

        for (const { from, to, fieldName } of dateFields) {
            if (!validateDateRange(from, to, fieldName)) {
                return; // Exit early if any date validation fails
            }
        }


        setIsfilterSearch(true);
        if (selectedTab === "Job Report") {
            setAdditionalFilter(prevFilter => ({
                ...prevFilter,
                placementType: formValues.placementType,
                clientName: formValues.clientName,
                divisionId: formValues.divisionId,
                teamId: formValues.teamId,
                requisitionStatus: formValues.requisitionStatus,
                requisionSubStatus: formValues.requistionSubStatus,
                start_date: formValues.start_date,
                offer_release_date: formValues.offer_release_date,
                interview_date: formValues.interview_date,
                clientJobId: formValues.clientJobId
                // joining_date : formValues.joining_date,
            }));
        }
        else if (selectedTab === "Submission Report") {
            setAdditionalFilter_submission(prevFilter => ({
                ...prevFilter,
                clientName: formValues.clientName,
                divisionId: formValues.divisionId,
                teamId: formValues.teamId,
                start_date: formValues.start_date,
                selected_date: formValues.selected_date,
                offer_release_date: formValues.offer_release_date,
                interview_date: formValues.interview_date,
                joining_date: formValues.joining_date,
                statusList,
                clientJobId: formValues.clientJobId
            }));
        }
        else if (selectedTab === "Work Report") {
            setAdditionalFilter_workReport(prevFilter => ({
                ...prevFilter,
                clientName: formValues.clientName,
                divisionId: formValues.divisionId,
                teamId: formValues.teamId,
                start_date: formValues.start_date,
                selected_date: formValues.selected_date,
                offer_release_date: formValues.offer_release_date,
                interview_date: formValues.interview_date,
                clientJobId: formValues.clientJobId
            }))
        }
        else if (selectedTab === "Recruiter's Activity") {
            setAdditionalFilter_recruiter_activity(prevFilter => ({
                ...prevFilter,
                clientName: formValues.clientName,
                divisionId: formValues.divisionId,
            }))
        } else if (selectedTab === "Hiring Report") {
            setAdditionalFilter(prevFilter => ({
                ...prevFilter,
                placementType: formValues.placementType,
                clientName: formValues.clientName,
                divisionId: formValues.divisionId,
                clientJobId: formValues.clientJobId,
                teamId: formValues.teamId,
            }));
        }
        else if (selectedTab === "Access log Report") {
            setFilterValues_accessreport(prevFilter => ({
                ...prevFilter,
                email: formValues.email,
                ipAddress: formValues.ipAddress

            }));
        }
        else if (selectedTab === "Activity Report") {
            setAdditionalFilter_activity(prevFilter => ({
                ...prevFilter,
                email: formValues.email.length === 0 ? "" : formValues.email

            }));
        }
        else if (selectedTab === "Resume Report") {
            setAdditionalFilter_resume_report(prevFilter => ({
                ...prevFilter,
                divisionId: formValues.divisionId,
                teamId: formValues.teamId,
                email: formValues.email,
            }));
        }
        else if (selectedTab === "RTR Reports") {
            setAdditionalFilter_rtr_report(prevFilter => ({
                ...prevFilter,
                clientName: formValues.clientName,
                divisionId: formValues.divisionId,
                teamId: formValues.teamId,
                candidateName: formValues.candidateName,
                candidateEmail: formValues.candidateEmail,
                refId: formValues.refId,
                rtrStatus: formValues.rtrStatus,
                rtrSendDate: formValues.rtrSendDate,
                approvalDate: formValues.approvalDate,
                rejectDate: formValues.rejectDate
            }));
        }





    };


    // Filter out already selected candidate status options
    const filteredCandidateStatusOptions = candidateStatusOptions.filter(
        (option) => !formValues.candidateStatus.some(selected => selected.value === option.value)
    );

    return (
        <div className='search_main_Container' >
            <div className='search_btn_box'>
                <div className='text_top'>
                    <Typography className=''>Showing Results</Typography>
                    <Typography style={{ color: 'gray', marginTop: "2%" }}>{selectedTab}</Typography>
                </div>

                <div className='search_btn_top'>
                    <button className='search_btn' sx={{ cursor: "pointer" }} onClick={handleSearch}>Search</button>
                </div>
            </div>
            {/* <Box className='current_tab_search_name'>
                <Typography >{selectedTab} Search</Typography>
            </Box> */}

            <div className='search_form_container_job_search' >
                {(selectedTab === "Job Report") && (<form>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Division
                        </Typography>
                        <Autocomplete
                            multiple
                            options={allDivisionNames}
                            getOptionLabel={(option) => option.divisionName}
                            filterSelectedOptions
                            onChange={handleDivisionChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Division"
                                />
                            )}
                        />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Client Name
                        </Typography>
                        <Autocomplete
                            multiple
                            options={allClientNames}
                            getOptionLabel={(option) => option.clientName}
                            filterSelectedOptions
                            onChange={handleClientNameChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Client"
                                />
                            )}
                        />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Team
                        </Typography>
                        <Autocomplete
                            multiple
                            options={allTeamNames}
                            getOptionLabel={(option) => option.teamName}
                            filterSelectedOptions
                            onChange={handleTeamNameChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Team"
                                />
                            )}
                        />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Client Job ID
                        </Typography>
                        <TextField
                            variant="outlined"
                            fullWidth
                            placeholder="Enter Client Job ID"
                            onChange={(e) => handleAutocompleteChange(e, e.target.value, 'clientJobId')}
                        />
                    </div>
                    {selectedTab !== "Hiring Report" &&

                        <>
                            <div style={{ marginBottom: "10px" }}>
                                <Typography variant="subtitle1" gutterBottom>
                                    Requisition Status
                                </Typography>
                                <Autocomplete
                                    multiple
                                    options={statusNames}
                                    getOptionLabel={(option) => option.name}
                                    filterSelectedOptions
                                    onChange={(event, newValue) => handleAutocompleteChange(event, newValue, 'requisitionStatus')}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            placeholder="Select Status"
                                        />
                                    )}
                                />
                            </div>
                            {is_OPEN_Exist && (
                                <div style={{ marginBottom: "10px" }}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Requisition Sub Status
                                    </Typography>
                                    <Autocomplete
                                        multiple
                                        options={openSubList}
                                        getOptionLabel={(option) => option.subName}
                                        filterSelectedOptions
                                        onChange={(event, newValue) => handleAutocompleteChange(event, newValue, 'requisition_SubStatus')}

                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                                placeholder="Select Sub Status"
                                            />
                                        )}
                                    />
                                </div>
                            )}

                        </>



                    }
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Placement Type
                        </Typography>
                        <Autocomplete
                            multiple
                            options={placementTypeOption}
                            getOptionLabel={(option) => option.PositionType}
                            filterSelectedOptions
                            onChange={(event, newValue) => handleAutocompleteChange(event, newValue, 'placementType')}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Placement Type"
                                />
                            )}
                        />
                    </div>
                </form>)}


                {(selectedTab === "Hiring Report") && (<form>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Division
                        </Typography>
                        <Autocomplete
                            multiple
                            options={allDivisionNames}
                            getOptionLabel={(option) => option.divisionName}
                            filterSelectedOptions
                            onChange={handleDivisionChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Division"
                                />
                            )}
                        />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Client Name
                        </Typography>
                        <Autocomplete
                            multiple
                            options={allClientNames}
                            getOptionLabel={(option) => option.clientName}
                            filterSelectedOptions
                            onChange={handleClientNameChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Client"
                                />
                            )}
                        />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Client Job ID
                        </Typography>
                        <TextField
                            variant="outlined"
                            fullWidth
                            placeholder="Enter Client Job ID"
                            onChange={(e) => handleAutocompleteChange(e, e.target.value, 'clientJobId')}
                        />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Team
                        </Typography>
                        <Autocomplete
                            multiple
                            options={allTeamNames}
                            getOptionLabel={(option) => option.teamName}
                            filterSelectedOptions
                            onChange={handleTeamNameChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Team"
                                />
                            )}
                        />
                    </div>
                    {selectedTab !== "Hiring Report" &&

                        <div style={{ marginBottom: "10px" }}>
                            <Typography variant="subtitle1" gutterBottom>
                                Requisition Status
                            </Typography>
                            <Autocomplete
                                multiple
                                options={statusNames}
                                getOptionLabel={(option) => option.name}
                                filterSelectedOptions
                                onChange={(event, newValue) => handleAutocompleteChange(event, newValue, 'requisitionStatus')}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select Status"
                                    />
                                )}
                            />
                        </div>
                    }
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Placement Type
                        </Typography>
                        <Autocomplete
                            multiple
                            options={placementTypeOption}
                            getOptionLabel={(option) => option.PositionType}
                            filterSelectedOptions
                            onChange={(event, newValue) => handleAutocompleteChange(event, newValue, 'placementType')}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Placement Type"
                                />
                            )}
                        />
                    </div>
                </form>)}


                {selectedTab === "Resume Report" && (<form>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Division
                        </Typography>
                        <Autocomplete
                            multiple
                            options={allDivisionNames}
                            getOptionLabel={(option) => option.divisionName}
                            filterSelectedOptions
                            onChange={handleDivisionChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Division"
                                />
                            )}
                        />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Team
                        </Typography>
                        <Autocomplete
                            multiple
                            options={allTeamNames}
                            getOptionLabel={(option) => option.teamName}
                            filterSelectedOptions
                            onChange={handleTeamNameChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Team"
                                />
                            )}
                        />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Email
                        </Typography>
                        <TextField variant="outlined" placeholder="Enter Email" className='access_search' fullWidth onChange={handleActivityEmail} onKeyDown={(e) => {
                            if (e.key === ' ') {
                                e.preventDefault();
                            }
                        }} />
                    </div>


                </form>)}


                {selectedTab === "Submission Report" && (<form>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Division
                        </Typography>
                        <Autocomplete
                            multiple
                            options={allDivisionNames}
                            getOptionLabel={(option) => option.divisionName}
                            filterSelectedOptions
                            onChange={handleDivisionChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Division"
                                />
                            )}
                        />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Client Name
                        </Typography>
                        <Autocomplete
                            multiple
                            options={allClientNames}
                            getOptionLabel={(option) => option.clientName}
                            filterSelectedOptions
                            onChange={handleClientNameChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Client"
                                />
                            )}
                        />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Team
                        </Typography>
                        <Autocomplete
                            multiple
                            options={allTeamNames}
                            getOptionLabel={(option) => option.teamName}
                            filterSelectedOptions
                            onChange={handleTeamNameChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Team"
                                />
                            )}
                        />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Client Job ID
                        </Typography>
                        <TextField
                            variant="outlined"
                            fullWidth
                            placeholder="Enter Client Job ID"
                            onChange={(e) => handleAutocompleteChange(e, e.target.value, 'clientJobId')}
                        />
                    </div>
                    <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Candidate Status
                        </Typography>
                        <Autocomplete
                            multiple
                            options={filteredCandidateStatusOptions}
                            value={formValues.candidateStatus}
                            getOptionLabel={(option) => option.label}
                            onChange={handleStatusChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Candidate Status"
                                />
                            )}
                        />
                    </div>

                    <div className='createRequisition_datapicker'>
                        <Typography variant="subtitle1" gutterBottom className='color_report'>
                            Joining Date
                        </Typography>
                        <div style={{ display: 'flex', justifyContent: 'space-around', gap: '20px' }}>
                            <div>
                                <Typography style={{ color: "grey" }} className="text_color_subheading" variant="subtitle2" gutterBottom >
                                    From
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.start_date.from ? new Date(formValues.start_date.from) : null}
                                    onChange={(date) => handleDateChange(date, 'start_date', 'from')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                            <div>
                                <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                    To
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.start_date.to ? new Date(formValues.start_date.to) : null}
                                    onChange={(date) => handleDateChange(date, 'start_date', 'to')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                        </div>
                    </div>

                    {/* Adding Joing Date Filters */}

                    <div className='createRequisition_datapicker' style={{ marginBottom: "10px", marginTop: "15px" }}>
                        <Typography variant="subtitle1" gutterBottom className='color_report'>
                            Selected Date
                        </Typography>
                        <div style={{ display: 'flex', justifyContent: 'space-around', gap: '20px' }}>
                            <div>
                                <Typography style={{ color: "grey" }} className="text_color_subheading" variant="subtitle2" gutterBottom >
                                    From
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.joining_date.from ? new Date(formValues.joining_date.from) : null}
                                    onChange={(date) => handleDateChange(date, 'joining_date', 'from')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                            <div>
                                <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                    To
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.joining_date.to ? new Date(formValues.joining_date.to) : null}
                                    onChange={(date) => handleDateChange(date, 'joining_date', 'to')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                        </div>
                    </div>

                    <div className='createRequisition_datapicker' style={{ marginBottom: "10px", marginTop: "15px" }}>
                        <Typography variant="subtitle1" gutterBottom className='color_report'>
                            Start Date
                        </Typography>
                        <div style={{ display: 'flex', justifyContent: 'space-around', gap: '20px' }}>
                            <div>
                                <Typography style={{ color: "grey" }} className="text_color_subheading" variant="subtitle2" gutterBottom >
                                    From
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.selected_date.from ? new Date(formValues.selected_date.from) : null}
                                    onChange={(date) => handleDateChange(date, 'selected_date', 'from')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                            <div>
                                <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                    To
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.selected_date.to ? new Date(formValues.selected_date.to) : null}
                                    onChange={(date) => handleDateChange(date, 'selected_date', 'to')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                        </div>
                    </div>


                    <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Offer Release Date
                        </Typography>
                        <div style={{ display: 'flex', justifyContent: 'space-around', gap: '20px' }}>
                            <div>
                                <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                    From
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.offer_release_date.from ? new Date(formValues.offer_release_date.from) : null}
                                    onChange={(date) => handleDateChange(date, 'offer_release_date', 'from')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                            <div>
                                <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                    To
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.offer_release_date.to ? new Date(formValues.offer_release_date.to) : null}
                                    onChange={(date) => handleDateChange(date, 'offer_release_date', 'to')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Interview Date
                        </Typography>
                        <div style={{ display: 'flex', justifyContent: 'space-around', gap: '20px' }}>
                            <div>
                                <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                    From
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.interview_date.from ? new Date(formValues.interview_date.from) : null}
                                    onChange={(date) => handleDateChange(date, 'interview_date', 'from')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                            <div>
                                <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                    To
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.interview_date.to ? new Date(formValues.interview_date.to) : null}
                                    onChange={(date) => handleDateChange(date, 'interview_date', 'to')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                        </div>
                    </div>
                </form>)
                }
                {selectedTab === "Work Report" && (<form>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Division
                        </Typography>
                        <Autocomplete
                            multiple
                            options={allDivisionNames}
                            getOptionLabel={(option) => option.divisionName}
                            filterSelectedOptions
                            onChange={handleDivisionChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Division"
                                />
                            )}
                        />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Client Name
                        </Typography>
                        <Autocomplete
                            multiple
                            options={allClientNames}
                            getOptionLabel={(option) => option.clientName}
                            filterSelectedOptions
                            onChange={handleClientNameChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Client"
                                />
                            )}
                        />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Team
                        </Typography>
                        <Autocomplete
                            multiple
                            options={allTeamNames}
                            getOptionLabel={(option) => option.teamName}
                            filterSelectedOptions
                            onChange={handleTeamNameChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Team"
                                />
                            )}
                        />
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Client Job ID
                        </Typography>
                        <TextField
                            variant="outlined"
                            fullWidth
                            placeholder="Enter Client Job ID"
                            onChange={(e) => handleAutocompleteChange(e, e.target.value, 'clientJobId')}
                        />
                    </div>
                    <div className='createRequisition_datapicker' style={{ marginBottom: "10px", marginTop: "15px" }}>
                        <Typography variant="subtitle1" gutterBottom className='color_report'>
                            Selected Date
                        </Typography>
                        <div style={{ display: 'flex', justifyContent: 'space-around', gap: '20px' }}>
                            <div>
                                <Typography style={{ color: "grey" }} className="text_color_subheading" variant="subtitle2" gutterBottom >
                                    From
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.selected_date.from ? new Date(formValues.selected_date.from) : null}
                                    onChange={(date) => handleDateChange(date, 'selected_date', 'from')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                            <div>
                                <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                    To
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.selected_date.to ? new Date(formValues.selected_date.to) : null}
                                    onChange={(date) => handleDateChange(date, 'selected_date', 'to')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                        </div>
                    </div>
                    <div className='createRequisition_datapicker'>
                        <Typography variant="subtitle1" gutterBottom className='color_report'>
                            Start Date
                        </Typography>
                        <div style={{ display: 'flex', justifyContent: 'space-around', gap: '20px' }}>
                            <div>
                                <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                    From
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.start_date.from ? new Date(formValues.start_date.from) : null}
                                    onChange={(date) => handleDateChange(date, 'start_date', 'from')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                            <div>
                                <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                    To
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.start_date.to ? new Date(formValues.start_date.to) : null}
                                    onChange={(date) => handleDateChange(date, 'start_date', 'to')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                        </div>
                    </div>


                    <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Offer Release Date
                        </Typography>
                        <div style={{ display: 'flex', justifyContent: 'space-around', gap: '20px' }}>
                            <div>
                                <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                    From
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.offer_release_date.from ? new Date(formValues.offer_release_date.from) : null}
                                    onChange={(date) => handleDateChange(date, 'offer_release_date', 'from')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                            <div>
                                <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                    To
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.offer_release_date.to ? new Date(formValues.offer_release_date.to) : null}
                                    onChange={(date) => handleDateChange(date, 'offer_release_date', 'to')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                        </div>
                    </div>
                    <div style={{ marginBottom: "10px" }}>
                        <Typography variant="subtitle1" gutterBottom>
                            Interview Date
                        </Typography>
                        <div style={{ display: 'flex', justifyContent: 'space-around', gap: '20px' }}>
                            <div>
                                <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                    From
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.interview_date.from ? new Date(formValues.interview_date.from) : null}
                                    onChange={(date) => handleDateChange(date, 'interview_date', 'from')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"

                                />
                            </div>
                            <div>
                                <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                    To
                                </Typography>
                                <DatePicker
                                    className="createRequisition_textbox_datapicker_reports_filter"
                                    selected={formValues.interview_date.to ? new Date(formValues.interview_date.to) : null}
                                    onChange={(date) => handleDateChange(date, 'interview_date', 'to')}
                                    dateFormat="MM-dd-yyyy"
                                    placeholderText="MM-DD-YYYY"
                                />
                            </div>
                        </div>
                    </div>
                </form>)
                }
                {
                    selectedTab === "Recruiter's Activity" && (<form>
                        <div style={{ marginBottom: "10px" }}>
                            <Typography variant="subtitle1" gutterBottom>
                                Division
                            </Typography>
                            <Autocomplete
                                multiple
                                options={allDivisionNames}
                                getOptionLabel={(option) => option.divisionName}
                                filterSelectedOptions
                                onChange={handleDivisionChange}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select Division"
                                    />
                                )}
                            />
                        </div>
                        <div style={{ marginBottom: "10px" }}>
                            <Typography variant="subtitle1" gutterBottom>
                                Client Name
                            </Typography>
                            <Autocomplete
                                multiple
                                options={allClientNames}
                                getOptionLabel={(option) => option.clientName}
                                filterSelectedOptions
                                onChange={handleClientNameChange}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select Client"
                                    />
                                )}
                            />
                        </div>
                    </form>)
                }
                {
                    (selectedTab === "Access log Report") && (<form>
                        <div style={{ marginBottom: "10px" }}>
                            <Typography variant="subtitle1" gutterBottom>
                                Email
                            </Typography>

                            <TextField variant="outlined" placeholder="Enter Email" className='access_search' fullWidth onChange={handleEmailChange} />
                        </div>
                        <div style={{ marginBottom: "10px" }}>
                            <Typography variant="subtitle1" gutterBottom>
                                Ip Address
                            </Typography>
                            <TextField variant="outlined" placeholder="Enter IP Address" className='access_search' fullWidth onChange={handleIPChange} />
                        </div>
                    </form>)
                }



                {
                    (selectedTab === "Activity Report") && (<form>
                        <div style={{ marginBottom: "10px" }}>
                            <Typography variant="subtitle1" gutterBottom>
                                Email
                            </Typography>
                            <TextField variant="outlined" placeholder="Enter Email" className='access_search' fullWidth onChange={handleActivityEmail} onKeyDown={(e) => {
                                if (e.key === ' ') {
                                    e.preventDefault();
                                }
                            }} />
                        </div>
                    </form>)
                }

                {
                    selectedTab === "RTR Reports" && (<form>
                        {/* <div style={{ marginBottom: "10px" }}>
                            <Typography variant="subtitle1" gutterBottom>
                                Division
                            </Typography>
                            <Autocomplete
                                multiple
                                options={allDivisionNames}
                                getOptionLabel={(option) => option.divisionName}
                                filterSelectedOptions
                                onChange={handleDivisionChange}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select Division"
                                    />
                                )}
                            />
                        </div>
                        <div style={{ marginBottom: "10px" }}>
                            <Typography variant="subtitle1" gutterBottom>
                                Client Name
                            </Typography>
                            <Autocomplete
                                multiple
                                options={allClientNames}
                                getOptionLabel={(option) => option.clientName}
                                filterSelectedOptions
                                onChange={handleClientNameChange}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select Client"
                                    />
                                )}
                            />
                        </div> */}
                        <div style={{ marginBottom: "10px" }}>
                            <Typography variant="subtitle1" gutterBottom>
                                Team
                            </Typography>
                            <Autocomplete
                                multiple
                                options={allTeamNames}
                                getOptionLabel={(option) => option.teamName}
                                filterSelectedOptions
                                onChange={handleTeamNameChange}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select Team"
                                    />
                                )}
                            />
                        </div>
                        <div style={{ marginBottom: "10px" }}>
                            <Typography variant="subtitle1" gutterBottom>
                                Candidate Name
                            </Typography>
                            <TextField
                                variant="outlined"
                                fullWidth
                                placeholder="Enter Candidate Name"
                                onChange={(e) => handleAutocompleteChange(e, e.target.value, 'candidateName')}
                            />
                        </div>
                        <div style={{ marginBottom: "10px" }}>
                            <Typography variant="subtitle1" gutterBottom>
                                Candidate Email
                            </Typography>
                            <TextField
                                variant="outlined"
                                fullWidth
                                placeholder="Enter Candidate Email"
                                onChange={(e) => handleAutocompleteChange(e, e.target.value, 'candidateEmail')}
                            />
                        </div>
                        <div style={{ marginBottom: "10px" }}>
                            <Typography variant="subtitle1" gutterBottom>
                                Requisition ID
                            </Typography>
                            <TextField
                                variant="outlined"
                                fullWidth
                                placeholder="Enter Requisition ID"
                                onChange={(e) => handleAutocompleteChange(e, e.target.value, 'refId')}
                            />
                        </div>
                        <div style={{ marginBottom: "10px" }}>
                            <Typography variant="subtitle1" gutterBottom>
                                RTR Status
                            </Typography>
                            <Autocomplete
                                options={rtrStatusOptions}
                                getOptionLabel={(option) => option.label}
                                value={rtrStatusOptions.find(option => option.value === formValues.rtrStatus) || null}
                                onChange={(event, newValue) => {
                                    const statusValue = newValue ? newValue.value : "";
                                    handleAutocompleteChange(event, statusValue, 'rtrStatus');
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select RTR Status"
                                    />
                                )}
                            />
                        </div>
                        <div style={{ marginBottom: "10px", marginTop: "15px" }}>
                            <Typography variant="subtitle1" gutterBottom>
                                Date Type
                            </Typography>
                            <FormControl component="fieldset">
                                <FormGroup row>
                                    <FormControlLabel 
                                        control={
                                            <Checkbox 
                                                checked={selectedDateType === "send"}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelectedDateType("send");
                                                        // Reset other date fields
                                                        setFormValues(prevValues => ({
                                                            ...prevValues,
                                                            approvalDate: { from: "", to: "" },
                                                            rejectDate: { from: "", to: "" }
                                                        }));
                                                    } else {
                                                        setSelectedDateType("");
                                                        setFormValues(prevValues => ({
                                                            ...prevValues,
                                                            rtrSendDate: { from: "", to: "" }
                                                        }));
                                                    }
                                                }}
                                            />
                                        } 
                                        label="RTR Send Date" 
                                    />
                                    <FormControlLabel 
                                        control={
                                            <Checkbox 
                                                checked={selectedDateType === "approval"}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelectedDateType("approval");
                                                        // Reset other date fields
                                                        setFormValues(prevValues => ({
                                                            ...prevValues,
                                                            rtrSendDate: { from: "", to: "" },
                                                            rejectDate: { from: "", to: "" }
                                                        }));
                                                    } else {
                                                        setSelectedDateType("");
                                                        setFormValues(prevValues => ({
                                                            ...prevValues,
                                                            approvalDate: { from: "", to: "" }
                                                        }));
                                                    }
                                                }}
                                            />
                                        } 
                                        label="Approval Date" 
                                    />
                                    <FormControlLabel 
                                        control={
                                            <Checkbox 
                                                checked={selectedDateType === "reject"}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelectedDateType("reject");
                                                        // Reset other date fields
                                                        setFormValues(prevValues => ({
                                                            ...prevValues,
                                                            rtrSendDate: { from: "", to: "" },
                                                            approvalDate: { from: "", to: "" }
                                                        }));
                                                    } else {
                                                        setSelectedDateType("");
                                                        setFormValues(prevValues => ({
                                                            ...prevValues,
                                                            rejectDate: { from: "", to: "" }
                                                        }));
                                                    }
                                                }}
                                            />
                                        } 
                                        label="Reject Date" 
                                    />
                                </FormGroup>
                            </FormControl>
                        </div>

                        {selectedDateType === "send" && (
                            <div className='createRequisition_datapicker' style={{ marginBottom: "10px", marginTop: "15px" }}>
                                <Typography variant="subtitle1" gutterBottom>
                                    RTR Send Date
                                </Typography>
                                <div style={{ display: 'flex', justifyContent: 'space-around', gap: '20px' }}>
                                    <div>
                                        <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                            From
                                        </Typography>
                                        <DatePicker
                                            className="createRequisition_textbox_datapicker_reports_filter"
                                            selected={formValues.rtrSendDate.from ? new Date(formValues.rtrSendDate.from) : null}
                                            onChange={(date) => handleDateChange(date, 'rtrSendDate', 'from')}
                                            dateFormat="MM-dd-yyyy"
                                            placeholderText="MM-DD-YYYY"
                                        />
                                    </div>
                                    <div>
                                        <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                            To
                                        </Typography>
                                        <DatePicker
                                            className="createRequisition_textbox_datapicker_reports_filter"
                                            selected={formValues.rtrSendDate.to ? new Date(formValues.rtrSendDate.to) : null}
                                            onChange={(date) => handleDateChange(date, 'rtrSendDate', 'to')}
                                            dateFormat="MM-dd-yyyy"
                                            placeholderText="MM-DD-YYYY"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {selectedDateType === "approval" && (
                            <div className='createRequisition_datapicker' style={{ marginBottom: "10px", marginTop: "15px" }}>
                                <Typography variant="subtitle1" gutterBottom>
                                    Approval Date
                                </Typography>
                                <div style={{ display: 'flex', justifyContent: 'space-around', gap: '20px' }}>
                                    <div>
                                        <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                            From
                                        </Typography>
                                        <DatePicker
                                            className="createRequisition_textbox_datapicker_reports_filter"
                                            selected={formValues.approvalDate.from ? new Date(formValues.approvalDate.from) : null}
                                            onChange={(date) => handleDateChange(date, 'approvalDate', 'from')}
                                            dateFormat="MM-dd-yyyy"
                                            placeholderText="MM-DD-YYYY"
                                        />
                                    </div>
                                    <div>
                                        <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                            To
                                        </Typography>
                                        <DatePicker
                                            className="createRequisition_textbox_datapicker_reports_filter"
                                            selected={formValues.approvalDate.to ? new Date(formValues.approvalDate.to) : null}
                                            onChange={(date) => handleDateChange(date, 'approvalDate', 'to')}
                                            dateFormat="MM-dd-yyyy"
                                            placeholderText="MM-DD-YYYY"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {selectedDateType === "reject" && (
                            <div className='createRequisition_datapicker' style={{ marginBottom: "10px", marginTop: "15px" }}>
                                <Typography variant="subtitle1" gutterBottom>
                                    Reject Date
                                </Typography>
                                <div style={{ display: 'flex', justifyContent: 'space-around', gap: '20px' }}>
                                    <div>
                                        <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                            From
                                        </Typography>
                                        <DatePicker
                                            className="createRequisition_textbox_datapicker_reports_filter"
                                            selected={formValues.rejectDate.from ? new Date(formValues.rejectDate.from) : null}
                                            onChange={(date) => handleDateChange(date, 'rejectDate', 'from')}
                                            dateFormat="MM-dd-yyyy"
                                            placeholderText="MM-DD-YYYY"
                                        />
                                    </div>
                                    <div>
                                        <Typography style={{ color: "grey" }} variant="subtitle2" gutterBottom>
                                            To
                                        </Typography>
                                        <DatePicker
                                            className="createRequisition_textbox_datapicker_reports_filter"
                                            selected={formValues.rejectDate.to ? new Date(formValues.rejectDate.to) : null}
                                            onChange={(date) => handleDateChange(date, 'rejectDate', 'to')}
                                            dateFormat="MM-dd-yyyy"
                                            placeholderText="MM-DD-YYYY"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </form>)
                }



            </div >
        </div >
    );
};

export default JobReportSearch;
